import { useState, useEffect, useRef } from 'react';

export default function FittingCanvasAttackAngle(props) {
  const [ctx, setCtx] = useState({});
  const intl = props.intl;
  const intlShallow = intl.formatMessage({id: "now.hitting.shallow"});
  const intlAttack = intl.formatMessage({id: "now.hitting.attack"});
  const intlAngle = intl.formatMessage({id: "now.hitting.angle"});
  const intlSteep = intl.formatMessage({id: "now.hitting.steep"});

  const canvasRef = useRef(null)

  //keeps canvas drawing ratios clean
  //http://www.petecorey.com/blog/2019/08/19/animating-a-canvas-with-react-hooks/
  const getPixelRatio = context => {
    var backingStore =
      context.backingStorePixelRatio ||
      context.webkitBackingStorePixelRatio ||
      context.mozBackingStorePixelRatio ||
      context.msBackingStorePixelRatio ||
      context.oBackingStorePixelRatio ||
      context.backingStorePixelRatio ||
      1;

    return (window.devicePixelRatio || 1) / backingStore;
  };

  useEffect(() => {
    const canvas = canvasRef.current;
    const context = canvas.getContext('2d');
    setCtx(context);

    let ratio = getPixelRatio(context);
    let width = getComputedStyle(canvas)
      .getPropertyValue('width')
      .slice(0, -2);
    let height = getComputedStyle(canvas)
      .getPropertyValue('height')
      .slice(0, -2);

    canvas.width = width * ratio;
    canvas.height = height * ratio;
    canvas.style.width = `${width}px`;
    canvas.style.height = `${height}px`;

    drawBackground(context, canvas);
  })

  function canvas_arrow(context, fromx, fromy, tox, toy) {
    var headlen = 10; // length of head in pixels
    var dx = tox - fromx;
    var dy = toy - fromy;
    var angle = Math.atan2(dy, dx);
    context.moveTo(fromx, fromy);
    context.lineTo(tox, toy);
    context.lineTo(tox - headlen * Math.cos(angle - Math.PI / 6), toy - headlen * Math.sin(angle - Math.PI / 6));
    context.moveTo(tox, toy);
    context.lineTo(tox - headlen * Math.cos(angle + Math.PI / 6), toy - headlen * Math.sin(angle + Math.PI / 6));
    context.stroke();
  }

  function drawBackground(ctx, canvas) {
    let height = canvas.height;
    let width = canvas.width;
    ctx.clearRect(0, 0, width, height);
    ctx.font = '12px arial';
    ctx.strokeStyle = 'darkgray';
    ctx.fillStyle = 'darkgray';

    ctx.fillText(intlAttack, 10, height * .49);
    ctx.fillText(intlAngle, 10, height * .52);
    ctx.fillText(intlShallow, 10, height * .05);
    ctx.fillText(intlSteep, 10, height * .95);
    canvas_arrow(ctx, 28, height*.44, 28, height*.07)
    canvas_arrow(ctx, 28, height*.55, 28, height*.90)
  }


  return (
    <>
      <canvas ref={canvasRef} style={{border: '0px'}} {...props}/><br />
    </>
  )
}
